import { useEffect, useState } from 'react';
import PropTypes, { object } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Box, Card, CardHeader, FormControl, MenuItem, Select } from '@mui/material';
// utils
import { fNumber } from '../../../utils/formatNumber';
// components
import { useChart } from '../../../components/chart';
import { getDashboardData } from '../../../redux/actions/userlistaction';
import CONSTANT from '../../../utils/constant.json';
// ----------------------------------------------------------------------

AppConversionRates.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
};

export default function AppConversionRates({ title, subheader, ...other }) {
  const dispatch = useDispatch();
  const [periods, setPeriods] = useState('Yearly');
  const [Year, setYear] = useState('2023');
  const [month, setMonth] = useState('January');
  const [chartLabels, setChartLabels] = useState([]);
  const [chartSeries, setChartSeries] = useState([]);

  const [select, setSelect] = useState(true);

  useEffect(() => {
    getUserDashboardData(Year, month);
  }, [Year, month, select, periods]);
  const chartData2 = useSelector((state) => state?.User?.getDashboard?.data?.User?.data);

  useEffect(() => {
    setChartLabels(
      select
        ? Object.keys(CONSTANT.MONTHS)
        : [...new Array(CONSTANT.MONTH_DAYS[CONSTANT.MONTHS[month]] + 1).keys()].slice(
            1,
            CONSTANT.MONTH_DAYS[CONSTANT.MONTHS[month]] + 1
          )
    );
    setChartSeries(
      select
        ? Object.keys(CONSTANT.MONTHS)?.map((item) => {
            return chartData2?.[item] ? chartData2?.[item] : 0;
          })
        : [...new Array(CONSTANT.MONTH_DAYS[CONSTANT.MONTHS[month]] + 1).keys()]
            .slice(1, CONSTANT.MONTH_DAYS[CONSTANT.MONTHS[month]] + 1)
            .map((item) => {
              return chartData2?.[item] ? chartData2?.[item] : 0;
            })
    );
  }, [chartData2]);

  const handleSelect = (e) => {
    const value = e.target.value;
    if (value === 'Yearly') {
      setPeriods(value);
      setSelect(true);
    } else if (value === 'Monthly') {
      setPeriods(value);
      setSelect(false);
    }
    // getUserDashboardData(Year, month);
  };

  const handleYearSelect = (e) => {
    const value = e.target.value;
    setYear(value);
    getUserDashboardData(value, month);
  };

  const handelMonthSelect = (e) => {
    const value = e.target.value;
    setMonth(value);
    // getUserDashboardData(Year, value);
  };

  const getUserDashboardData = (year, month) => {
    const obj = {
      type: ['User'],
      period: periods,
      value: select ? year : month,
    };
    dispatch(getDashboardData(obj));
  };

  const chartOptions = useChart({
    tooltip: {
      marker: { show: false },
      // y: {
      //   formatter: (seriesName) => fNumber(seriesName),
      //   title: {
      //     formatter: () => '',
      //   },
      // },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '50%',
        borderRadius: 2,
        dataLabels: {
          enabled: false,
        },
      },
    },

    xaxis: {
      categories: chartLabels,
    },
    yaxis: {
      labels: {
        formatter(val) {
          return val.toFixed(0);
        },
      },
    },
  });

  const filteredmonthData = month ? [month] : month;

  return (
    <Card {...other}>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: '10px' }}>
        <CardHeader title={title} subheader={subheader} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FormControl size="small">
            <Select id="demo-select-small" value={periods} sx={{ width: '120px' }} onChange={handleSelect}>
              <MenuItem value="Yearly">Yearly</MenuItem>
              <MenuItem value="Monthly">Monthly</MenuItem>
            </Select>
          </FormControl>
          {select ? (
            <FormControl size="small">
              <Select id="demo-select-small" value={Year} sx={{ width: '120px' }} onChange={handleYearSelect}>
                <MenuItem value="2021">2021</MenuItem>
                <MenuItem value="2022">2022</MenuItem>
                <MenuItem value="2023">2023</MenuItem>
              </Select>
            </FormControl>
          ) : (
            <FormControl size="small">
              <Select id="demo-select-small" value={month} sx={{ width: '120px' }} onChange={handelMonthSelect}>
                {Object.keys(CONSTANT.MONTHS).map((item) => {
                  return (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        </Box>
      </Box>
      <Box sx={{ mx: 3 }} dir="ltr">
        <ReactApexChart type="bar" series={[{ data: chartSeries }]} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
